import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgEyeOpenIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm1-3.313a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      fill="currentColor"
    />
    <path
      d="M12 19c-6 0-8.286-4.22-9-6.533C3.714 10.289 6.514 5 12 5c5.486 0 8.286 5.289 9 7.467C20.286 14.508 17.496 19 12 19Z"
      stroke="currentColor"
      strokeWidth={1.5}
    />
  </svg>
);

const ForwardRef = forwardRef(SvgEyeOpenIcon);
const Memo = memo(ForwardRef);
export default Memo;
